import { render, staticRenderFns } from "./RedirectSettingEdit.vue?vue&type=template&id=93c9bb92"
import script from "./RedirectSettingEdit.vue?vue&type=script&lang=js"
export * from "./RedirectSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./RedirectSettingEdit.vue?vue&type=style&index=0&id=93c9bb92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports